import { RolesApiAdapter } from '../adapters/RolesApiAdapter';
import { Filters, RolesModel } from '../models/Roles';

export interface Page {
  roles: RolesModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class Service {
  constructor(private apiAdapter: RolesApiAdapter) {}

  async getAllMovements(filters: Filters = {}): Promise<RolesModel[]> {
    return this.apiAdapter.getAll();
  }

  async getPaginatedMovements(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    // 🧠 Validaciones opcionales
    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getRolesPaginated(filters);
  }

  async getPaginated(filters: Filters = {}): Promise<Page> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getRolesPaginated(filters);
  }
}
